import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./Contexts/AuthContext";

export default function PrivateRoute() {
  const { getCurrentUser } = useAuth()

  return getCurrentUser() ? <Outlet /> : <Navigate to="/login" />
}
